/**
 * Query key factory for the dashboards feature.
 *
 * Three dashboards share a single namespace — keyed by dashboard id +
 * filter args — so cross-dashboard invalidations stay easy.
 */
export const dashboardKeys = {
  all: ['dashboards'] as const,
  admin: () => [...dashboardKeys.all, 'admin'] as const,
  adminWithLimit: (limit?: number) =>
    [...dashboardKeys.admin(), { limit: limit ?? null }] as const,
};
